import PropTypes from 'prop-types';
import ShowComponent from '../hocs/ShowComponent';

const PanelComponent = props => (
  <div className={`panel-component ${props.classNames}`}>
    { props.children }
  </div>
);

PanelComponent.propTypes = {
  classNames: PropTypes.string,
  children: PropTypes.node,
};

PanelComponent.defaultProps = {
  children: '',
  classNames: '',
};

export default ShowComponent(PanelComponent);
